<!--
 * @description: 底部信息
 * @Author: Jay
 * @Date: 2021-09-24 10:38:50
 * @LastEditors: Jay
 * @LastEditTime: 2021-10-22 17:05:48
-->
<template>
  <div>
    <div class="bottom-code text-black font_size_sm" v-if="putData != ''">
      <div>
        为博物馆、科研院校、中小学校、研学基地提供矿物、宝石、古生物化石、现生动植物标本；提供以实物标本和互动定制内容为载体的科普解决方案。
      </div>
      <div class="margin-top-xs" v-if="usData != ''">
        版权所有：{{ putData[1].value }}
        <span class="padding-left-xs"> 电话:</span>
        <span @click="copy(usData[2].value)" class="padding-right-xs">
          {{ usData[2].value }}
        </span>
        <span class="padding-left-xs"> 邮箱:</span>
        <span @click="copy(usData[3].value)" class="padding-right-xs">
          {{ usData[3].value }}
        </span>
      </div>
      <div class="margin-top-xs">
        ICP备案编号：
        <a href="https://beian.miit.gov.cn/"> {{ putData[0].value }} </a>
      </div>
    </div>
  </div>
</template>

<script>
import { banben, contactus } from "../../api/api";
export default {
  name: "rootBottom",
  data() {
    return {
      putData: [],
      usData: [],
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      //备案号
      banben().then((res) => {
        // console.log(res);
        this.putData = res.data;
      });

      //联系我们
      contactus().then((res) => {
        // console.log(res);
        this.usData = res.data;
      });
    },
    //复制
    copy(url) {
      // 创建一个 Input标签
      const cInput = document.createElement("input");
      cInput.value = url;
      document.body.appendChild(cInput);
      cInput.select(); // 选取文本域内容;
      // 执行浏览器复制命令
      // 复制命令会将当前选中的内容复制到剪切板中（这里就是创建的input标签）
      // Input要在正常的编辑状态下原生复制方法才会生效
      document.execCommand("Copy");
      //提示
      this.$message({
        message: "复制成功",
        type: "success",
      });
      /// 复制成功后再将构造的标签 移除
      cInput.remove();
    },
  },
};
</script>

<style lang="scss" scoped>
//底部高度
.bottom-code {
  padding: 20px;
  text-align: center;
  // width: 100%;
  background-color: #f2f2f2;
}
a {
  color: #333;
}
</style>